import { Component, OnInit, Renderer2 } from '@angular/core';
import { DatePipe, formatDate } from '@angular/common';
import { UserService } from 'src/app/service/user.service';
import { TranslationService } from 'src/app/service/api/translation.service';
import { TranslationRequest } from 'src/app/shared/models/TranslationRequest';

declare function doLiveChat(params: any): any;

@Component({
  selector: 'app-technical-difficulties',
  template: `
    <div>
      <div
        class="alert alert-danger technical-diff tw-w-[90%] md:tw-w-[60%] app-mt7"
      >
        {{ 'We are currently experiencing technical difficulties.' | translation : translationRequest }}
        <br /><br />
        {{ 'We apologize for any inconvenience.' | translation : translationRequest }}
        <br /><br />
        {{ 'You can go back to the' | translation : translationRequest }}
        <a tabindex="0" href="/" class="spanLink">{{ 'login page' | translation : translationRequest }}</a> {{ 'and try again.' | translation : translationRequest }}
        <br /><br />
        {{ 'Please feel free to call us at the following numbers and times:' | translation : translationRequest }}
        <br /><br />
        {{ 'Live Chat help is available from 8:00 a.m. until 5:00 p.m., Central Time, Monday through Friday.' | translation : translationRequest }}
        <br /><br />
        {{ 'Sedgwick Technical Support is available from 7:00 a.m. to 6:00 p.m., Central Time, Monday through Friday.' | translation : translationRequest }}
        <br /><br />
        {{'Toll-free number' | translation : translationRequest }}: (866) 647-7610
        <br /><br />
        {{'Toll number' | translation : translationRequest }}: (901) 415-7800

        <div *ngIf="hasSessionId">
          <span>
            <br />
            {{ 'Please have the following information available.' | translation : translationRequest }}
            <br /><br />
            <span>
              {{ 'Session ID' | translation : translationRequest }}: <span>{{ sessionId }} </span>
              <br />
              <span>
                {{ currentDate }}
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .technical-diff {
        padding: 20px;
        margin-left: 25px;
      }
    `,
  ],
  providers: [DatePipe],
})
export class TechnicalDifficultiesComponent implements OnInit {
  hasSessionId: boolean;
  sessionId: string;
  currentDate: string = new Date().toString();
  passVar: any;
  lhnHocButton: any;
  displayLocation: any;
  translationRequest: TranslationRequest = new TranslationRequest(
    {
      language: sessionStorage.getItem('languagepreference'),
      key: null,
      contNum: 0,
      tableName: null,
      primaryKey: null,
      primaryValue: null,
      lob: null,
      group: 'Shared',
      subGroup: 'Shared'
    }
  );

  constructor(
    private userService: UserService,
    private datePipe: DatePipe,
    private renderer: Renderer2,
    public translationService: TranslationService
  ) {
    this.currentDate = this.datePipe.transform(
      this.currentDate,
      'M/d/yyyy, h:mm:ss a'
    );
  }

  async ngOnInit(): Promise<void> {
    this.loadTranslations();
    this.sessionId = this.userService.sessionid;
    if (this.sessionId != undefined) this.hasSessionId = true;

    this.passVar = {
      Flag: '',
      top: '',
      left: window.innerWidth,
    };

    doLiveChat(this.passVar);
  }

  loadTranslations(): void {
    this.translationService.getTranslation(this.translationRequest);
  }
}
